import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const addGlobalError = createAction('[Errors] Add AddGlobalError', props<{ error: HttpErrorResponse }>());
